import { CommodityDetail } from 'features/contracts/enums/commodityDetail';
import React from 'react';
import { FuelingTransactionViewType } from '../enums/fuelingTransactionViewType';
import { useTranslation } from 'react-i18next';

type Props = {
  fuelingUnit: string;
  commodityDetail: CommodityDetail;
  viewType: FuelingTransactionViewType;
}

const FuelingSummaryDetailHeader = ({ fuelingUnit, commodityDetail, viewType }: Props) => {
  // transaltions
  const tLabels = useTranslation("fueling\\fueling").t;
  const tViewTypes = useTranslation("fueling\\enums\\fuelingTransactionViewType").t;

  // render
  return (
    <div className="d-none d-sm-block px-3 mb-2 text-muted font-weight-bold mr-5">
      <div className="row no-gutters align-items-center">
        <div className="col-sm text-truncate">
          {tViewTypes(viewType)}
        </div>
        <div className="col-sm text-sm-center">
          {tLabels(`fuelingSummaryDetailHeader.fuelingSum.${commodityDetail}`)}
          <small> [{fuelingUnit}]</small>
        </div>
        <div className="col-sm text-sm-center">
          {tLabels(`fuelingSummaryDetailHeader.fuelingCount.${commodityDetail}`)}
        </div>
        <div className="col-sm text-sm-center">
          {tLabels("fuelingSummaryDetailHeader.totalAmount")}
        </div>
      </div>
    </div>
  );
}

export default FuelingSummaryDetailHeader;